export const teamIconStyles = {
    display: "inline-block",
    width: "16px",
    height: "17px",
    marginRight: "8px",
    verticalAlign: "bottom",
};
export const teamNamesStyles = {
    $extendFromVariant: "default",
    root: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        lineHeight: "inherit",
    },
};
export const getServingIndicatorStyles = (isTeamOneServing) => ({
    display: "block",
    position: "absolute",
    width: "3px",
    height: "14px",
    backgroundColor: "#F7D002",
    left: "0px",
    bottom: `${isTeamOneServing ? "71px" : "42px"}`,
    borderTopRightRadius: "8px",
    borderBottomRightRadius: "8px"
});
//# sourceMappingURL=variants.js.map